import React, { useState } from "react";
import styles from "./TextBlock.module.css";
import MoreButton from "../../../reusable/Button/MoreButton";
import AlignmentMenu from "../AlignmentMenu";
import { center, left, right } from "../Alignment.module.css";

export default function TextBlock(props) {
	const [state, setState] = useState({
		showAlignmentMenu: false,
	});

	const alignments = {
		center: center,
		left: left,
		right: right,
	};

	const handleAlignmentMenu = () => {
		setState({
			showAlignmentMenu: !state.showAlignmentMenu,
		});
	};

	const closeAlignmentMenu = () => {
		setState({
			showAlignmentMenu: false,
		});
	};

	const changeAlignment = (alignment) => {
		setState({
			showAlignmentMenu: false,
		});
		if (alignment !== props.alignment)
			return props.changeAlignment(alignment);
	};

	return (
		<div className={styles.textBlock}>
			{state.showAlignmentMenu ? (
				<AlignmentMenu
					setAlignment={changeAlignment}
					onClose={closeAlignmentMenu}
				/>
			) : null}
			<div className={styles.moreBtn}>
				<MoreButton action={handleAlignmentMenu} />
			</div>
			<textarea
				className={`${styles.textArea} ${
					alignments[props.alignment] || left
				}`}
				placeholder="Content"
				value={props.content || ""}
				onChange={(e) => props.onChange(e.target.value)}
				autoComplete="off"
			/>
		</div>
	);
}
